<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div>
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title">
              质检模板明细
            </div>
            <div class="content_head_button">
<!--              <div class="content_head_seek">-->
<!--                <lk-button img="add.png" @click="QCDetails('新增')">新增</lk-button>-->
<!--              </div>-->
              <div class="content_head_seek">
                <el-input placeholder="输入质检模板" v-model="queryCheckNumber" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="getQCList(1)"></el-button>
                </el-input>
              </div>
            </div>
          </div>
          <div class="Notice_list">
            <el-table
                :data="QCTemplateDetail"
                style="width: 100%"
            >
              <el-table-column
                  prop="grKind"
                  label="粮食品种"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="QCTemplate"
                  label="质检模板"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="type"
                  label="质检模板类型"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="QCName"
                  label="质检项"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="standardFloor"
                  label="标准下限"
                  align="center"
                  width="90">
              </el-table-column>
              <el-table-column
                  prop="standardVal"
                  label="标准值"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="standardUpper"
                  label="标准上限"
                  align="center"
                  width="90">
              </el-table-column>
              <el-table-column
                  prop="stepLength"
                  label="步长"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="ladderAdd"
                  label="扣杂标准%"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="detailState"
                  label="明细状态"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="description"
                  label="描述"
                  align="center"
                  width="250">
              </el-table-column>
              <el-table-column
                  prop="addTime"
                  label="添加时间"
                  align="center">
              </el-table-column>
<!--              <el-table-column-->
<!--                  label="操作"-->
<!--                  align="center"-->
<!--                  width="120"-->
<!--              >-->
<!--                <template slot-scope="scope">-->
<!--                  <el-button type="text" size="small" @click="QCDetails('详情',scope.row)">详情</el-button>-->
<!--                  <el-button type="text" size="small" @click="QCDetails('编辑',scope.row)">编辑</el-button>-->
<!--                  <el-button type="text" size="small" @click="QCDetails('删除',scope.row)" style="color: red">删除-->
<!--                  </el-button>-->
<!--                </template>-->
<!--              </el-table-column>-->
            </el-table>
          </div>
          <!--          分页器-->
          <div class="paging">
            <div class="block">
              <el-pagination
                  background
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  layout="total, prev, pager, next, jumper"
                  :total="totalQuantity">
              </el-pagination>
            </div>
          </div>
          <!--        新增，详细，编辑弹窗-->
          <el-dialog
              :title="dialogTitle"
              :visible.sync="redactShow"
              width="30%"
          >
            <div class="dialog_content" v-if="dialogTitle==='详情'||dialogTitle==='删除'">
              <p>质检模板: {{ QCTemplateCN }}</p>
              <p>粮食品种: {{ grKind }}</p>
              <p>质检项: {{ QCNameCN }}</p>
              <p>标准下限: {{ standardFloor }}</p>
              <p>标准值: {{ standardVal }}</p>
              <p>标准上限: {{ standardUpper }}</p>
              <p>步长: {{ stepLength }}</p>
              <p>扣杂标准%: {{ ladderAdd }}</p>
              <p>标准描述: {{ description }}</p>
              <p>明细状态: {{ detailState }}</p>
            </div>
            <div class="dialog_content" v-if="dialogTitle==='编辑'||dialogTitle==='新增'">
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检模板:</span>
                <el-select v-model="QCTemplate" placeholder="请选择" :disabled="dialogTitle==='编辑'" @change="dataReturn()">
                  <el-option
                      v-for="item in QCTemplateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>粮食品种:</span>
                <el-input v-model="grKind" disabled></el-input>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检项:</span>
                <el-select v-model="QCName" placeholder="请选择" :disabled="dialogTitle==='编辑'">
                  <el-option
                      v-for="item in QCNameList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>标准下限:</span>
                <el-input v-model="standardFloor" placeholder="标准下限"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>标准值:</span>
                <el-input v-model="standardVal" placeholder="标准值"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>标准上限:</span>
                <el-input v-model="standardUpper" placeholder="标准上限"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>步长:</span>
                <el-input v-model="stepLength" placeholder="步长"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>扣杂标准%:</span>
                <el-input v-model="ladderAdd" placeholder="扣杂标准"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>明细状态:</span>
                <el-select v-model="detailState" placeholder="请选择">
                  <el-option
                      v-for="item in detailStateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>标准描述:</span>
                <el-input v-model="description" type="textarea" placeholder="描述"></el-input>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="redactShow = false">取消</el-button>
              <el-button type="primary" @click="addQCDate" v-if="dialogTitle==='新增'">保存</el-button>
              <el-button type="primary" @click="upQCDate" v-if="dialogTitle==='编辑'">保存</el-button>
              <el-button type="danger" @click="QCDelete" v-if="dialogTitle==='删除'">删除</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpToken} from '@/utils/http'
import qs from 'qs'

export default {
  name: 'Tempdetail',
  data() {
    return {
      QCTemplateDetail: [],
      ids: '',
      QCTemplate: '',
      QCTemplateCN: '',
      QCName: '',
      QCNameCN: '',
      grKind: '',
      standardFloor: 0,
      standardVal: 0,
      standardUpper: 0,
      stepLength: 0,
      ladderAdd: 0,
      detailState: '必选项',
      description: '',
      addTime: '',
      QCTemplateList: [],
      QCNameList: [],
      detailStateList: [
        {value: '必选项'},
        {value: '非必须项'}
      ],
      QCTemplateDetailALL: [],
      currentPage: 1,
      totalQuantity: 10,
      queryCheckNumber: '',
      redactShow: false,
      dialogTitle: '',
      current: 1
    }
  },
  methods: {
    // 选择模板后回显模板内粮食品种
    dataReturn() {
      httpToken({
        url: '/mould/show',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify([{column: "mould_code", type: 'eq', value: this.QCTemplate}])
        })
      }).then(res => {
        if (res.data.code === 200) {
          this.grKind = res.data.data.grKindCn
        }
      })
    },
    //新增质检项数据
    addQCDate() {
      if (this.QCTemplate === '') {
        this.$message({
          message: '请选择质检模板',
          type: 'error'
        })
      } else if (this.QCName === '') {
        this.$message({
          message: '请选择质检项',
          type: 'error'
        })
      } else {
        httpToken({
          url: '/mouldDetail/save',
          method: 'post',
          data: {
            chMoId: this.QCTemplate,
            chItemId: this.QCName,
            denyLowerLi: this.standardFloor,
            denyUpperLi: this.standardUpper,
            status: this.detailState,
            chDescribe: this.description,
            standardVal: this.standardVal,
            stepLength: this.stepLength,
            ladderAdd: this.ladderAdd
          }
        }).then(res => {
          this.redactShow = false
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getQCList(this.currentPage)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 编辑上传
    upQCDate() {
      if (this.QCTemplate === '') {
        this.$message({
          message: '请选择质检模板',
          type: 'error'
        })
      } else if (this.QCName === '') {
        this.$message({
          message: '请选择质检项',
          type: 'error'
        })
      } else {
        httpToken({
          url: '/mouldDetail/update',
          method: 'post',
          data: {
            id: this.ids,
            chMoId: this.QCTemplate,
            chItemId: this.QCName,
            denyLowerLi: this.standardFloor,
            denyUpperLi: this.standardUpper,
            status: this.detailState,
            chDescribe: this.description,
            standardVal: this.standardVal,
            stepLength: this.stepLength,
            ladderAdd: this.ladderAdd
          }
        }).then(res => {
          this.redactShow = false
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.getQCList(this.currentPage)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 获取质检项数据
    getQCList(page, max) {
      let paramData = [{ column: "create_date", type: "orderByDesc"}]
      if (this.queryCheckNumber) {
        paramData.push({column: "ch_mo_cn",type: 'like',value: this.queryCheckNumber})
      }
      httpToken({
        url: '/mouldDetail/list',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
          page: page,
          rows: 10
        })
      }).then(res => {
        if (max === 1) {
          if (res.data.data.current !== page || res.data.data.current !== res.data.data.pages) {
            this.getQCList(res.data.data.pages)
            return;
          }
        } else if (max === 2) {
          if (res.data.data.current !== page) {
            this.getQCList(res.data.data.pages)
            return;
          }
        }
        const QCALL = res.data.data
        this.QCTemplateDetail = []
        for (let q = 0; q < QCALL.records.length; q++) {
          const QC = QCALL.records[q]
          this.QCTemplateDetail.push(
            {
              ids: QC.id,
              QCTemplateId: QC.chMoId,
              QCTemplate: QC.chMoCn,
              grKind: QC.grKindCn,
              type: QC.type,
              QCNameId: QC.chItemId,
              QCName: QC.chItemCn,
              standardFloor: QC.denyLowerLi,
              standardVal: QC.standardVal,
              stepLength: QC.stepLength,
              ladderAdd: QC.ladderAdd,
              standardUpper: QC.denyUpperLi,
              detailState: QC.status,
              description: QC.chDescribe,
              addTime: QC.createDate.replace('T', ' '),
            }
          )
        }
        this.totalQuantity = QCALL.total
        this.currentPage = page
      })
    },
    // 详情和编辑和新增按键
    QCDetails(val, state) {
      this.redactShow = true
      this.dialogTitle = val
      if (state) {
        this.ids = state.ids
        this.QCTemplate = state.QCTemplateId
        this.QCTemplateCN = state.QCTemplate
        this.QCName = state.QCNameId
        this.QCNameCN = state.QCName
        this.standardFloor = state.standardFloor
        this.standardUpper = state.standardUpper
        this.detailState = state.detailState
        this.description = state.description
        this.grKind = state.grKind
        this.standardVal = state.standardVal
        this.stepLength = state.stepLength
        this.ladderAdd = state.ladderAdd
      } else {
        this.ids = ''
        this.QCTemplate = ''
        this.QCName = ''
        this.standardFloor = ''
        this.standardUpper = ''
        this.detailState = ''
        this.description = ''
        this.grKind = ''
        this.standardVal = ''
        this.stepLength = ''
        this.ladderAdd = ''
      }
    },
    // 删除质检项信息
    QCDelete() {
      httpToken({
        url: '/mouldDetail/delete',
        method: 'post',
        data: qs.stringify({ids: this.ids})
      }).then(res => {
        if (res.data.code === 200) {
          this.redactShow = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getQCList(this.currentPage, 2)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    // 质检模板下拉
    tempListOpstions() {
      let paramData = [{column: "id", type: '', value: ''}]
      httpToken({
        url: '/mould/all',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
        })
      }).then(res => {
        const QCALL = res.data.data
        this.QCTemplateList = []
        // console.log(QCALL)
        for (let q = 0; q < QCALL.length; q++) {
          const QC = QCALL[q]
          this.QCTemplateList.push(
              {
                "value": QC.mouldCode,
                "label": QC.grKindCn + '-' + QC.mouldName + '-' + QC.mouldTypeCn
              }
          )
        }
      })
    },
    // 质检项下拉
    itemListOpstions() {
      let paramData = [{column: "id", type: '', value: ''}]
      httpToken({
        url: '/item/all',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
        })
      }).then(res => {
        const QCALL = res.data.data
        this.QCNameList = []
        // console.log(QCALL)
        for (let q = 0; q < QCALL.length; q++) {
          const QC = QCALL[q]
          this.QCNameList.push(
              {
                "value": QC.id,
                "label": QC.checkNumber + '-' + QC.checkName
              }
          )
        }
      })
    },
    // 切换页码
    handleCurrentChange(val) {
      this.getQCList(val)
    }
  },
  mounted() {
    this.getQCList(1)
    this.tempListOpstions()
    this.itemListOpstions()
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #F5F8FF;
  }

  ::v-deep .el-table thead {
    color: #000000
  }
}

.dialog_content {
  //margin-bottom: 30px;

  p {
    margin-bottom: 10px;
  }

  .dialog_content_c {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      text-align: right;
      width: 30%;
      padding-right: 10px;
    }

    .el-select {
      width: 60%;
      margin: auto 0;
    }

    .el-input {
      width: 60%;
      margin: auto 0;
    }

    .el-textarea {
      width: 60%;
      margin: auto 0;
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
